import { axios, API } from './config';

export const setupTemplatesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/setup-templates`);
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(`${API}/setup-templates`, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API}/setup-templates/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axios.delete(`${API}/setup-templates/${id}`);
    return response.data;
  },
};
